// extracted by mini-css-extract-plugin
export var contact = "educationContent-module--contact--oKoOd";
export var contactLabel = "educationContent-module--contactLabel--cjinr";
export var contactText = "educationContent-module--contactText--tCiJb";
export var fill = "educationContent-module--fill--QBhkk";
export var left = "educationContent-module--left--DbE2h";
export var main = "educationContent-module--main--dbwl0";
export var right = "educationContent-module--right--G5QcR";
export var secondImage = "educationContent-module--secondImage--4lgKm";
export var section = "educationContent-module--section--8HLmr";